import React from 'react';
import { FaDiscord } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import DonationAlert from '../../components/pix/DonationAlert';
import './Nexus.css';
import Navbar from '../../components/Navbar';
import LogoNexus from '../../img/LogoNexus.png';

const Nexus = () => {

  return (
    <div className="nexus-container">
      <DonationAlert />
      <Navbar />
      <header className="nexus-header">
        <div className="stars"></div>
        <div className="twinkling"></div>
        <div className="nexus-content">
          <div className="logo-container">
            <img src={LogoNexus} alt="Nexus Logo" className="nexus-logo" />
          </div>
          <p className="nexus-subtitle">Um servidor Minecraft Modpack Survival!</p>
          <div className="nexus-divider"></div>
          <p className="nexus-description">Onde mundos se encontram e aventuras começam...</p>
          
          <a 
            href="https://discord.gg/9W4Vusc4m2" 
            target="_blank" 
            rel="noopener noreferrer"
            className="nexus-button"
          >
            <FaDiscord className="discord-icon" />
            <span>Entrar no Discord</span>
          </a>
        </div>
      </header>
      
      <section id="sobre" className="about-section">
        <div className="container">
          <h2 className="section-title">Sobre o Nexus</h2>
          <div className="divider"></div>
          
          <div className="about-content">
            <p className="about-text">
              O Nexus é um projeto dedicado a criar uma experiência única de Minecraft Modpack Survival. Nosso objetivo é oferecer um mundo onde cada jogador pode explorar, construir e deixar sua marca, enquanto aproveita um modpack leve, otimizado e cuidadosamente balanceado para garantir desempenho estável e diversão sem interrupções.
            </p>
            
            <p className="about-text">
              O servidor é projetado para SMP (Survival Multiplayer), com whitelist para preservar uma comunidade comprometida e acolhedora, incentivando a colaboração, criatividade e a imersão na lore do universo Nexus. Aqui, suas escolhas importam: cada ação ajuda a moldar o mundo ao seu redor, transformando cada aventura em uma história única.
            </p>
            
            <h3 className="about-subtitle">Principais destaques do Nexus:</h3>
            
            <ul className="features-list">
              <li><strong>Modpack Exclusivo:</strong> Mods escolhidos para diversão, exploração e performance.</li>
              <li><strong>Mundo Persistente:</strong> Construções e conquistas ficam salvas para sempre.</li>
              <li><strong>Acessível e Otimizado:</strong> Experiência completa, mesmo para computadores menos potentes.</li>
            </ul>
            
            <p className="about-text">
              O Nexus não é apenas um servidor ou um modpack. É um universo em constante evolução, onde cada jogador é uma peça importante. Aqui, você encontra liberdade para criar, explorar e viver aventuras que vão além do convencional.
            </p>
            
            <blockquote className="about-quote">
              "No Nexus, cada jogador é uma estrela em nossa galáxia."
            </blockquote>
          </div>
        </div>
      </section>

      <section id="doacao" className="donation-section">
        <div className="container">
          <h2 className="section-title">Apoie o Projeto</h2>
          <div className="divider"></div>
          
          <div className="donation-content">
            <p>Ajude a manter o servidor online e a melhorar ainda mais a experiência do Nexus SMP! Sua doação é essencial para cobrirmos os custos de hospedagem e manutenção do servidor.</p>
            
            <div className="donation-methods">
              <div className="donation-method">
                <h3>Pix</h3>
                <div className="pix-code">
                  <p>Escaneie o QR Code PIX:</p>
                  <div style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    borderRadius: '12px',
                    margin: '20px auto',
                    maxWidth: '280px',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
                  }}>
                    <img 
                      src="/img/pix-qr-code.png" 
                      alt="QR Code para doação PIX" 
                      style={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                        maxWidth: '240px',
                        margin: '0 auto'
                      }}
                    />
                  </div>
                  <p style={{
                    fontSize: '0.85em',
                    color: '#d1c4e9',
                    margin: '15px 0 5px',
                    textAlign: 'center'
                  }}>
                    Use o app do seu banco para escanear o QR Code
                  </p>
                </div>
              </div>
            </div>
            
            <div className="donation-note" style={{
              marginTop: '20px',
              padding: '15px',
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '5px',
              borderLeft: '4px solid #4a148c'
            }}>
              <p style={{ margin: 0 }}>
                <strong>Observação:</strong> As doações são voluntárias e serão utilizadas exclusivamente para a manutenção e melhoria do servidor. 
                <Link 
                  to="/termos#doacoes" 
                  style={{
                    color: '#b388ff',
                    textDecoration: 'none',
                    borderBottom: '1px dashed #b388ff',
                    transition: 'color 0.3s ease',
                    marginLeft: '4px'
                  }}
                  onMouseOver={(e) => e.target.style.color = '#e0d6ff'}
                  onMouseOut={(e) => e.target.style.color = '#b388ff'}
                >
                  Leia nossos termos de doação
                </Link>. Agradecemos profundamente pelo seu apoio!
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="nexus-footer">
        <p>© 2024 Vih's Studio. Todos os direitos reservados. | <a href="/termos" className="footer-link">Termos de Serviço</a></p>
      </footer>
    </div>
  );
};

export default Nexus;
